import { http, queryString } from 'utils'

// Load mutation imports.
import { SET_LOADS } from 'vx/mutations'

// Load state.
const state = {
  loads: []
}

// Load state getters.
const getters = {}

// Load actions.
const actions = {
  /**
   * Get loads for a job.
   */
  getLoads ({ commit, rootState: { job: jobState }, getters }, payload) {
    const job = jobState.job.id

    return http.get(`jobs/${job}/loads?${queryString(payload)}`).then(response => {
      commit(`load/${SET_LOADS}`, response.data, { root: true })

      return response
    })
  }
}

// Load state mutations.
const mutations = {}

// Export our state, getters, actions, and mutations.
export default {
  namespaced: true, state, getters, actions, mutations
}



// WEBPACK FOOTER //
// ./src/vuex/modules/job/load.js